(ns hai.interfaces.routes
  (:require [hai.interfaces.chat.routes :as chat]
            [hai.interfaces.slack.routes :as slack]
            [hai.interfaces.chrome-sidebar.routes :as chrome-sidebar]
            [hai.interfaces.sheets-sidebar.routes :as sheets-sidebar]
            [hai.interfaces.api.routes :as wherever]
            [hai.ui.components :as c]
            [hai.web-app.layout :as layout]
            [hai.web-app.routing :as routing]))

(defn interfaces-page
  [_]
  [layout/page
   [layout/title-bar
    [c/Heading "1 Humble, many interfaces"]]
   [:div "Humble works where you work!"]])

(defn routes []
  [["/interfaces"
    {::routing/window-title "Interfaces"}
    ["" {:name :interfaces
         :view interfaces-page}]
    ["/chat" {:name :interfaces/chat
              ::routing/window-title "Chat"
              :view chat/interfaces-chat-page}]
    ["/slack" {:name :interfaces/slack
               ::routing/window-title "Slack"
               :view slack/interfaces-slack-page}]
    ["/browser" {:name :interfaces/browser-ext
                 ::routing/window-title "Browser extension"
                 :view chrome-sidebar/interfaces-chrome-sidebar-page}]
    ["/sheets" {:name :interfaces/sheets
                ::routing/window-title "Google Sheets"
                :view interfaces-page}]
    ["/api" {:name :interfaces/api
             ::routing/window-title "API"
             :view interfaces-page}]]])